export default __webpack_public_path__ + "static/media/bridge.0510cd8b.svg";